import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material'; // Paper kivéve
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';
import { motion } from 'framer-motion';

// Képek importálása
// @ts-ignore
import levendulaImg from '../videos/levendula.JPEG';
// @ts-ignore
import templomImg from '../videos/templom.JPEG';
// @ts-ignore
import pezsgoImg from '../videos/pezsgo.PNG';
// @ts-ignore
import templomImgIcon from '../videos/templom.PNG';

// Textúra beimportálása!
// @ts-ignore
import textureBg from '../videos/texture.png'; 

// Ikonok Type-castingja
const LocationIcon = FaMapMarkerAlt as any;
const ExternalLinkIcon = FiExternalLink as any;

const EventDetails: React.FC = () => {
  return (
    <Box 
      sx={{ 
        backgroundColor: 'primary.main', 
        py: { xs: 10, md: 15 }, 
        textAlign: 'center' 
      }}
    >
      <Container maxWidth="md">
        
        {/* FŐCÍMEK ÉS BEVEZETŐ */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography 
            variant="body1" 
            sx={{ letterSpacing: 3, color: 'text.secondary',  fontSize: '1.8rem' }}
          >
            VÁRUNK SZERETETTEL
          </Typography>
          <Typography 
            variant="body2" 
            sx={{  color: 'text.secondary', fontSize: '1.1rem' }}
          >
            Alig várjuk, hogy veletek ünnepelhessük ezt a különleges napot. Itt találtok minden fontos információt a helyszínekről.
          </Typography>
        </Box>

        {/* 1. HELYSZÍN: LEVENDULÁS */}
        <Box id="levendulas-helyszin" sx={{ mb: 8 }}>
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }} 
            transition={{ duration: 0.8 }}
          >
            <Box 
              sx={{ 
                bgcolor: '#001A3F', 
                borderRadius: 4, 
                p: { xs: 3, md: 6 },
                textAlign: 'center',
                boxShadow: '0 4px 20px rgba(0,0,0,0.3)' 
              }}
            >
              
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                <Box 
                  sx={{ 
                    width: 60, height: 60, 
                    borderRadius: '50%', 
                    bgcolor: 'rgba(255, 255, 255, 0.05)', 
                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                    overflow: 'hidden' 
                  }}
                >
                  <Box 
                    component="img"
                    src={pezsgoImg}
                    alt="Pezsgő"
                    sx={{
                      width: 28, 
                      height: 28,
                      objectFit: 'contain'
                    }}
                  />
                </Box>
              </Box>

              <Typography variant="h3" sx={{ color: '#fff', mb: 2 }}>
                Vacsora és Buli
              </Typography>
              
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3, fontSize: '1.1rem' }}>
                A polgári szertartást és az azt követő hatalmas ünneplést ezen a csodálatos helyszínen tartjuk.
              </Typography>

              <Box sx={{ mb: 4, color: 'text.secondary' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
                  <LocationIcon size={16} color="#FFD700" />
                  <Typography variant="h6" sx={{  fontWeight: 500, color: '#fff' }}>
                    Levendulás Rendezvényház
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ fontSize: '1rem' }}>
                  Inárcs, Major 1-4.
                </Typography>
              </Box>

              <Box 
                component="a" 
                href="https://maps.app.goo.gl/tZnwVczvxi26yFqy5" 
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  display: 'block',
                  width: '100%', 
                  mb: 4, 
                  borderRadius: 2, 
                  overflow: 'hidden', 
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  '&:hover img': { transform: 'scale(1.03)' } 
                }}
              >
                <Box 
                  component="img"
                  src={levendulaImg}
                  alt="Levendulás Rendezvényház"
                  sx={{
                    width: '100%',
                    height: '350px',
                    objectFit: 'cover', 
                    display: 'block',
                    transition: 'transform 0.5s ease',
                  }}
                />
              </Box>

              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', gap: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<ExternalLinkIcon />}
                  href="https://maps.app.goo.gl/tZnwVczvxi26yFqy5"
                  target="_blank"
                  sx={{ 
                    borderRadius: '30px', 
                    py: 1.5, px: 3,
                    borderColor: '#FFD700',
                    color: '#FFD700',
                    '&:hover': { borderColor: '#FFF', color: '#FFF' }
                  }}
                >
                  Térkép Megnyitása
                </Button>
              </Box>
            </Box>
          </motion.div>
        </Box>

        {/* 2. HELYSZÍN: BUGYI */}
        <Box id="bugyi-helyszin">
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }} 
            transition={{ duration: 0.8 }}
          >
            <Box 
              sx={{ 
                bgcolor: '#001A3F', 
                borderRadius: 4, 
                p: { xs: 3, md: 6 },
                textAlign: 'center',
                boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                <Box 
                  sx={{ 
                    width: 60, height: 60, 
                    borderRadius: '50%', 
                    bgcolor: 'rgba(255, 255, 255, 0.05)', 
                    display: 'flex', justifyContent: 'center', alignItems: 'center' 
                  }}
                >
                  <Box 
                    component="img"
                    src={templomImgIcon}
                    alt="Templom"
                    sx={{
                      width: 28,
                      height: 28,
                      objectFit: 'contain'
                    }}
                  />
                </Box>
              </Box>

              <Typography variant="h3" sx={{ color: '#fff', mb: 2 }}>
                Templomi Esküvő
              </Typography>
              
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3, fontSize: '1.1rem' }}>
                Kérjük, gyűljünk össze a templom előtt, ahol örök hűséget fogadunk egymásnak Isten színe előtt.
              </Typography>

              <Box sx={{ mb: 4, color: 'text.secondary' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
                  <LocationIcon size={16} color="#FFD700" />
                  <Typography variant="h6" sx={{  fontWeight: 500, color: '#fff' }}>
                    Bugyi Szent Adalbert templom
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{  fontSize: '1rem' }}>
                  2347 Bugyi, Kossuth Lajos utca
                </Typography>
              </Box>

              <Box 
                component="a" 
                href="https://www.google.com/maps/place/Bugyi+Szent+Adalbert+templom/@47.223586,19.1475386,17z/data=!3m1!4b1!4m6!3m5!1s0x4741f2e6b5d30d8f:0xebe39a9cb31eec9f!8m2!3d47.223586!4d19.1501189!16s%2Fg%2F11xb1d513?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D" 
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  display: 'block',
                  width: '100%', 
                  mb: 4, 
                  borderRadius: 2, 
                  overflow: 'hidden', 
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  '&:hover img': { transform: 'scale(1.03)' } 
                }}
              >
                <Box 
                  component="img"
                  src={templomImg}
                  alt="Bugyi Református Templom"
                  sx={{
                    width: '100%',
                    height: { xs: '250px', sm: '350px' },
                    objectFit: 'cover', 
                    objectPosition: 'top center', 
                    display: 'block',
                    transition: 'transform 0.5s ease',
                  }}
                />
              </Box>

              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', gap: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<ExternalLinkIcon />}
                  href="https://www.google.com/maps/place/Bugyi+Szent+Adalbert+templom/@47.223586,19.1475386,17z/data=!3m1!4b1!4m6!3m5!1s0x4741f2e6b5d30d8f:0xebe39a9cb31eec9f!8m2!3d47.223586!4d19.1501189!16s%2Fg%2F11xb1d513?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D" 
                  target="_blank"
                  sx={{ 
                    borderRadius: '30px', 
                    py: 1.5, px: 3,
                    borderColor: '#FFD700',
                    color: '#FFD700',
                    '&:hover': { borderColor: '#FFF', color: '#FFF' }
                  }}
                >
                  Térkép Megnyitása
                </Button>
              </Box>
            </Box>
          </motion.div>
        </Box>

      </Container>
    </Box>
  );
};

export default EventDetails;